<div class="data-table-wrapper animate-fade-in">
    <!-- Search Bar -->
    <div class="search-container" *ngIf="showSearch">
        <ion-searchbar [placeholder]="searchPlaceholder" (ionInput)="applyFilter($event)" class="glass-searchbar"
            [value]="searchTerm"></ion-searchbar>
    </div>

    <!-- Table View (Desktop & Tablet) -->
    <div class="desktop-view glass-card neon-border" *ngIf="!loading && hasData">
        <div class="table-container">
            <ion-grid class="pure-table">
                <ion-row class="header-row">
                    <ion-col *ngFor="let col of columns" [class]="col.cssClass"
                        [attr.size]="col.key === 'actions' ? 'auto' : ''">
                        {{col.label}}
                    </ion-col>
                    <ion-col *ngIf="actions.length > 0" class="center" size="auto">ACTIONS</ion-col>
                </ion-row>

                <ion-row *ngFor="let item of displayedData" class="data-row" (click)="onRowClick(item)">
                    <ion-col *ngFor="let col of columns" [class]="col.cssClass"
                        [attr.size]="col.key === 'actions' ? 'auto' : ''">
                        <ng-container [ngSwitch]="col.type">
                            <!-- Image/Avatar -->
                            <div *ngSwitchCase="'image'" class="avatar-cell">
                                <ion-avatar class="neon-glow-avatar mini">
                                    <img [src]="getCellValue(item, col) || 'assets/imgs/empty.svg'" />
                                </ion-avatar>
                            </div>

                            <!-- Badge/Status -->
                            <div *ngSwitchCase="'badge'" class="badge-cell">
                                <ion-badge [class]="col.badgeClass ? col.badgeClass(item) : 'neon-badge'">
                                    {{getCellValue(item, col)}}
                                </ion-badge>
                            </div>

                            <!-- Currency -->
                            <div *ngSwitchCase="'currency'" class="neon-text font-bold">
                                {{currencySymbol}}{{getCellValue(item, col) | number:'1.2-2'}}
                            </div>

                            <!-- Rating -->
                            <div *ngSwitchCase="'rating'" class="rating-cell">
                                <span class="value">{{getCellValue(item, col) || '0.0'}}</span>
                                <ion-icon name="star" class="neon-star"></ion-icon>
                            </div>

                            <!-- Phone/Email -->
                            <div *ngSwitchCase="'phone'" class="contact-cell">
                                <ion-icon name="call-outline" class="mini-icon"></ion-icon>
                                <span>{{getCellValue(item, col)}}</span>
                            </div>

                            <div *ngSwitchCase="'email'" class="contact-cell">
                                <ion-icon name="mail-outline" class="mini-icon"></ion-icon>
                                <small>{{getCellValue(item, col)}}</small>
                            </div>

                            <!-- Date -->
                            <div *ngSwitchCase="'date'" class="date-cell">
                                {{getCellValue(item, col) | date:'short'}}
                            </div>

                            <!-- Default Text -->
                            <div *ngSwitchDefault class="text-cell">
                                {{getCellValue(item, col)}}
                            </div>
                        </ng-container>
                    </ion-col>

                    <!-- Actions -->
                    <ion-col *ngIf="actions.length > 0" class="action-buttons center" size="auto">
                        <ion-button *ngFor="let action of actions" (click)="onActionClick(action.id, item, $event)"
                            fill="clear" [class]="'neon-btn mini ' + (action.cssClass || '')" [color]="action.color">
                            <ion-icon [name]="action.icon" slot="icon-only"></ion-icon>
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
    </div>

    <!-- Card View (Mobile) -->
    <div class="mobile-view" *ngIf="!loading && hasData">
        <div class="glass-card neon-border mobile-card animate-fade-in" *ngFor="let item of displayedData"
            (click)="onRowClick(item)">
            <div class="card-header" *ngIf="mobileCardTitleKey">
                <h3 class="agent-name">{{item[mobileCardTitleKey]}}</h3>
                <div class="card-actions" *ngIf="actions.length > 0">
                    <ion-button *ngFor="let action of actions" (click)="onActionClick(action.id, item, $event)"
                        fill="clear" [class]="'neon-btn mini ' + (action.cssClass || '')" [color]="action.color">
                        <ion-icon [name]="action.icon" slot="icon-only"></ion-icon>
                    </ion-button>
                </div>
            </div>

            <div class="card-body">
                <div class="detail-row" *ngFor="let col of columns">
                    <span class="label">{{col.label}}</span>
                    <div class="value">
                        <ng-container [ngSwitch]="col.type">
                            <ion-avatar *ngSwitchCase="'image'" class="neon-glow-avatar mini">
                                <img [src]="getCellValue(item, col) || 'assets/imgs/empty.svg'" />
                            </ion-avatar>
                            <ion-badge *ngSwitchCase="'badge'"
                                [class]="col.badgeClass ? col.badgeClass(item) : 'neon-badge'">
                                {{getCellValue(item, col)}}
                            </ion-badge>
                            <span *ngSwitchCase="'currency'" class="neon-text font-bold">
                                {{currencySymbol}}{{getCellValue(item, col) | number:'1.2-2'}}
                            </span>
                            <div *ngSwitchCase="'rating'" class="rating-cell">
                                <span class="value">{{getCellValue(item, col) || '0.0'}}</span>
                                <ion-icon name="star" class="neon-star"></ion-icon>
                            </div>
                            <span *ngSwitchDefault>{{getCellValue(item, col)}}</span>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="card-footer" *ngIf="actions.length > 0 && !mobileCardTitleKey">
                <ion-button *ngFor="let action of actions" (click)="onActionClick(action.id, item, $event)" fill="clear"
                    [class]="'neon-btn mini ' + (action.cssClass || '')" [color]="action.color">
                    <ion-icon [name]="action.icon" slot="icon-only"></ion-icon>
                    <span class="action-label" *ngIf="action.label">{{action.label}}</span>
                </ion-button>
            </div>
        </div>
    </div>

    <!-- Pagination -->
    <div class="pagination-footer glass-panel" *ngIf="!loading && hasData && totalPages > 1">
        <ion-button fill="clear" [disabled]="currentPage === 0" (click)="previousPage()" class="neon-btn mini">
            <ion-icon name="chevron-back-outline"></ion-icon>
        </ion-button>
        <div class="page-indicator">
            SECTOR {{ currentPage + 1 }} / {{ totalPages }}
        </div>
        <ion-button fill="clear" [disabled]="currentPage + 1 >= totalPages" (click)="nextPage()" class="neon-btn mini">
            <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
    </div>

    <!-- No Data -->
    <div class="no-data glass-card neon-border animate-fade-in" *ngIf="!loading && !hasData">
        <ion-icon name="journal-outline" class="neon-textLarge"></ion-icon>
        <h2 class="neon-text">NO ENTRIES FOUND</h2>
        <p>{{emptyMessage}}</p>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="skeleton-container ion-padding">
        <div class="glass-card neon-border ion-padding">
            <ion-skeleton-text animated style="height: 300px; width: 100%;"></ion-skeleton-text>
        </div>
    </div>
</div>